import React from 'react';
import classNames from 'classnames/bind';
import { Link } from 'react-router';

import ClickOutside from '../../../_ui/ClickOutside';
import styles from './SimpleDropDown.scss';


const cx = classNames.bind(styles);

// const propTypes = {
//   items: React.PropTypes.shape({
//     keys: React.PropTypes.array.isRequired,
//     data: React.PropTypes.object.isRequired,
//   }),
//   className: React.PropTypes.string,
//   current: React.PropTypes.number.isRequired,
//   path: React.PropTypes.string.isRequired,
// };

const defaultProps = {
};


class SimpleDropDown extends React.Component {
  state = {
    isOpen: false,
  }

  handleClick = (e) => {
    e.preventDefault();
    const isDropDown = this.props.items.keys.length > 1;
    if (isDropDown) {
      this.setState(prevState => ({
        isOpen: !prevState.isOpen,
      }));
    }
  }

  handleCollapse = () => {
    this.setState({
      isOpen: false,
    });
  }

  handleItemCollapse = (e, i) => {
    if (i === 0) {
      e.preventDefault();
    }
    this.handleCollapse();
  }

  renderDropDown = (keys, data, current, path) => {
    const { isOpen } = this.state;
    if (!isOpen) return null;
    const url = path.split('/');
    return (
      <div className={styles.dropdown}> {
        [current, ...keys.filter(item => !(item === current))].map((key, i) =>
          <Link
            to={[...url.slice(0, 2), key, ...url.slice(3)].join('/')}
            key={key}
            onClick={(e) => { this.handleItemCollapse(e, i); }}
          >
            {data[key]}&nbsp;
          </Link>
        )}
      </div>
    );
  }

  render() {
    const { items: { keys, data }, className, current, path, ...other } = this.props;
    const isDropDown = (keys.length > 1)
      && keys.includes(current); // TODO убрать потом, когда будет норм валидация
    return (
      <ClickOutside
        className={cx({ root: true }, className)}
        onClickOutside={this.handleCollapse}
      >
        <Link
          href=""
          className={cx({ text: true, usable: isDropDown })}
          onClick={this.handleClick}
          {...other}
        >
          {data[current]} {isDropDown && <span className={styles.arrow} />}
        </Link>
        {isDropDown && this.renderDropDown(keys, data, current, path)}
      </ClickOutside>
    );
  }
}


// SimpleDropDown.propTypes = propTypes;
SimpleDropDown.defaultProps = defaultProps;
export default SimpleDropDown;
